import VectorLayer from 'ol/layer/Vector';
import {Vector as VectorSource} from 'ol/source.js';
import {Feature} from 'ol';
import {Point} from 'ol/geom';
import {fromLonLat} from 'ol/proj';

import {Style, Stroke, Circle, Fill} from 'ol/style.js';

// import url from './data.geojson?url';

const vectorLayer = new VectorLayer({
    source: new VectorSource({
      loader: async function() {
        const res = await fetch("https://www.weather.gov/source/nwr/JS/ccl-data.js");
        const text = await res.text();
        const jsonText = text.replace("var cclData = ", "").replace(";", "");
        const data = JSON.parse(jsonText);
        console.log(data);
        for (let station of data) {
            const {counties, ...rest} = station;
            // Format for better display
            const processed_counties = Object.fromEntries(counties.map(c => [c.same, `${c.county}, ${c.st}`]))
            console.log([station.lon, station.lat].map(parseFloat))
            this.addFeature(new Feature({
                geometry: new Point(fromLonLat([station.lon, station.lat])),
                ...rest,
                // counties: processed_counties,
            }));
        }
      },
    }),
    style: function(feature, resolution) {
        let base_color;
        if (feature.get('status') === 'NORMAL') {
            base_color = '#00FF00';
        } else if (feature.get('status') === 'OUT OF SERVICE') {
            base_color = '#FF0000';
        } else {
            base_color = '#888888';
            console.log("Unknown status", feature.get('status'));
        }
        return new Style({
            image: new Circle({
                radius: 50/Math.pow(resolution, 1/4),
                fill: new Fill({color: base_color + '33'}),
                stroke: new Stroke({color: base_color, width: 1}),
            }),
        });
    }
});

console.log(vectorLayer);

export default vectorLayer;
